import Chats from '../forum/chats'
import Threads from '../forum/threads'
import Responses from '../forum/responses'
import SavedPosts from '../forum/savedPosts'
import Poll from '../forum/poll'

export default () => ({
  chats: Chats(),
  threads: Threads(),
  responses: Responses(),
  savedPosts: SavedPosts(),
  poll: Poll()
})
